import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";
import { useActiveSpaceData } from "../../hooks/useActiveSpaceData.hook";
import { getPermissions } from "../../utils/permissions";
import { saveHeaderDetails, deleteHeaderProject } from "../../firebase/headerActions";
import FavoriteStar from "../favorite-star/favorite-star.component";
import GoBackButton from "../ui-elements/gobackbutton";
import TitleActions from "../title-actions/TitleActions";
import "./station-info.styles.scss";

export default function StationInfo({ data, currentSpaceId, currentStationId, workspace }) {
  const cachedSpace = useActiveSpaceData(currentSpaceId);
  const space = workspace || cachedSpace;
  const uid = useSelector(state => state.user.currentUser?.uid);
  const navigate = useNavigate();
  if (!data) return null;
  const project = { ...data, fromSpaceId: currentSpaceId };
  const permissions = getPermissions(space ? { ...space, spaceId: currentSpaceId } : null, project, uid);
  return <div className="stationInfo">
    <GoBackButton />
    {space && <>
      <Link className="breadcrumb__spaceName" to={`/s/${currentSpaceId}`} title={space.name}>
        <span className="breadcrumb__spaceIcon" style={{ background: space.color || "#89afb4" }} aria-hidden="true">{(space.name || "W").charAt(0)}</span>
        <span className="breadcrumb__spaceLabel">{space.name || "Workspace"}</span>
      </Link>
      <BsChevronRight stroke="currentColor" strokeWidth={0.6} className="si__breadcrumb_arrowright" aria-hidden="true" />
    </>}
    <TitleActions key={`${currentSpaceId}:${currentStationId}`} kind="project" record={project}
      canEdit={permissions.canManageProject} canDelete={permissions.canManageProject}
      onSave={patch => {
        if (!permissions.canManageProject) throw new Error("You no longer have permission to edit this project.");
        return saveHeaderDetails(currentSpaceId, currentStationId, patch);
      }} onDelete={async () => {
        if (!permissions.canManageProject) throw new Error("You no longer have permission to delete this project.");
        await deleteHeaderProject(currentSpaceId, currentStationId);
        navigate(space ? `/s/${currentSpaceId}` : "/");
      }} />
    <span className="stationInfo__favorite"><FavoriteStar data={data} /></span>
  </div>;
}
